exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dashboard-container[data-v-60a680c5] {\n  color: rgba(0, 0, 0, 0.65);\n  padding: 16px;\n  text-align: center;\n}\n.dashboard-editor-container[data-v-60a680c5] {\n  background-color: white;\n  display: inline-block;\n  text-align: left;\n}\n", ""]);

// exports
